module.exports = __webpack_public_path__ + "static/img/gold.745e837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/gold.png
// module id = qvpx
// module chunks = 38